import _Model from "./_Model";

export default class CandidateAccessory extends _Model {
  constructor(json) {
    super(json);
    this.id = CandidateAccessory.getOrDefault(json, 'id', '');
    this.type = CandidateAccessory.getOrDefault(json, 'type', null);
  }
}
